import { render, staticRenderFns } from "./ObjectPageMobile.vue?vue&type=template&id=376a838b"
import script from "./ObjectPageMobile.vue?vue&type=script&lang=js"
export * from "./ObjectPageMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports